module.exports = __webpack_public_path__ + "img/brightness-alt-low.bd308321.svg";